const state = {
    legal_documentation: {},
};

const getters = {
    legalDocumentationState: (state) => state.legal_documentation,
};

const actions = {
    async doGetLegalDocumentation({ commit, rootState }) {
        let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            axios.get("/user/" + userId + "/legal-documentation").then(
                (response) => {
                    commit("setLegalDocumentation", response.data);
                    resolve(response.data);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doUpdateLegalDocumentation({ commit, rootState }, { legalDocumentation, fieldKey = "" }) {
        if (fieldKey) {
            let payload = {
                [fieldKey]: legalDocumentation[fieldKey],
            };
            let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
            return new Promise((resolve, reject) => {
                axios.patch("/user/" + userId + "/legal-documentation", payload).then(
                    (response) => {
                        commit("setLegalDocumentation", { legalDocumentation: response.data, fieldKey });
                        resolve(response.data);
                    },
                    (error) => {
                        console.log(error);
                        reject(error);
                    }
                );
            });
        }
    },
    async doGenerateW8BENUrl({ commit, rootState }) {
        let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            axios.get("/user/" + userId + "/legal-documentation/w8ben").then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doResetClientAgreementConfirmation({ commit, rootState, dispatch }) {
        let legalDocumentation = {
            client_agreement_confirmation: null,
        };
        dispatch("doUpdateLegalDocumentation", legalDocumentation);
    },
};
const mutations = {
    setLegalDocumentation: (state, {legalDocumentation, fieldKey = ""}) => {
        if(fieldKey){
            state.legal_documentation[fieldKey] = legalDocumentation[fieldKey];
        }
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
